// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"a3a36edb","375":"c497d979","695":"51e0addd","800":"805c2f22"}[chunkId] + ".chunk.js";
};